import type { BuddyId } from '../types/ids.js';
import type { SpriteFrames } from '../types/SpriteFrames.js';
import { jubitSprite } from './jubit.js';

/**
 * Sprite registry — lookup sprite frames by buddy id.
 * v1 has Jubit only; others come in Phase 2.
 */
export const SPRITES: Partial<Record<BuddyId, SpriteFrames>> = {
  jubit: jubitSprite,
};

/** Returns the sprite for a buddy, or a placeholder if not yet authored. */
export function getSprite(id: BuddyId): SpriteFrames {
  return SPRITES[id] ?? PLACEHOLDER_SPRITE;
}

export const PLACEHOLDER_SPRITE: SpriteFrames = {
  idle: [
    '  ┌───┐  ',
    '  │ ? │  ',
    '  │   │  ',
    '  └───┘  ',
  ],
  blink: [
    '  ┌───┐  ',
    '  │ ? │  ',
    '  │   │  ',
    '  └───┘  ',
  ],
};

export { jubitSprite };
